import { render, staticRenderFns } from "./plugin-folder.vue?vue&type=template&id=76ebfd0c&scoped=true&"
import script from "./plugin-folder.vue?vue&type=script&lang=js&"
export * from "./plugin-folder.vue?vue&type=script&lang=js&"
import style0 from "./plugin-folder.vue?vue&type=style&index=0&id=76ebfd0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ebfd0c",
  null
  
)

export default component.exports